import React from 'react';
import TabsIconSelector from './TabsIconSelector';
import { styled } from '@mui/material/styles';

const TabsNavigation = ({
  tabs,
  selectedIndex,
  onSelect,
  selectedIconBarColor,
}) => {
  return (
    <ScmTabSelectorWrapper>
      <TabsIconSelector
        tabs={tabs}
        selectedIndex={selectedIndex}
        onSelect={onSelect}
        selectedIconBarColor={selectedIconBarColor}
      />
    </ScmTabSelectorWrapper>
  );
};

const ScmTabSelectorWrapper = styled('div')(({ theme }) => ({
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px',
  backgroundColor: 'white',
  zIndex: 4,
  [theme.breakpoints.down('sm')]: {
    width: '330px',
    height: '188px',
    padding: '20px',
    paddingTop: '0px',
    marginTop: '-50px',
  },
  [theme.breakpoints.between('sm','md')]: {
    width: '568px',
    height: '188px',
    padding: '0px',
    marginTop: '-50px',
  },
  [theme.breakpoints.between('md','lg')]: {
    width: '700px',
    height: '188px',
    padding: '20px',
    marginTop: '-50px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '1248px',
    height: '188px',
    padding: '20px',
    marginTop: '-50px',
  },
}));

export default TabsNavigation;
